import { render } from "./EditPayrollEmployeeConfig.vue?vue&type=template&id=1c34fbee&scoped=true"
import script from "./EditPayrollEmployeeConfig.vue?vue&type=script&lang=js"
export * from "./EditPayrollEmployeeConfig.vue?vue&type=script&lang=js"

import "./EditPayrollEmployeeConfig.vue?vue&type=style&index=0&id=1c34fbee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c34fbee"]])

export default __exports__